<template>
    <div class="">
        <h1>{{ $t('labels.enter_row_percentage') }}</h1>

        <div class="actions actions--fixed">
            <div class="action action--wide" v-for="percentage in percentages" :key="percentage.value">
                <a href="#" :class="getButtonClasses(percentage)" @click.prevent="setRowPercentage(percentage.value)">
                    <span>{{ percentage.value }}%</span>
                </a>
            </div>
        </div>

        <div class="app-actions">
            <cancel-button :redirect="cancelRedirect()"></cancel-button>
        </div>
    </div>
</template>

<script>
    import CancelButton from "../components/app/CancelButton";
    import {writeTrackLog} from "../utils/tracking";

    export default {
        name: 'row-percentage',

        components: {CancelButton},

        computed: {
          currentDevice () {
            return this.$store.state.currentDevice;
          },

          percentages() {
            return this.$store.state.percentages;
          },

          currentActivity () {
            return this.$store.getters.currentActivityForEmployee
          },
        },

        methods: {
            getButtonClasses(percentage) {
                return {
					'action-button': true,
                    'active': this.currentActivity && this.currentActivity.row_percentage && this.currentActivity.row_percentage === percentage.value
                };
            },

			cancelRedirect () {
				if (this.$store.state.enableTracking) writeTrackLog("Cancel from: " + this.$route.name);

				if (this.currentActivity) {
					const activity = this.$store.getters.activityById(this.currentActivity.activity_id);

					if (this.currentDevice.pre_register_activities) {
            if (activity.register_row_status) return {name: 'row-status'};
						if (activity.register_row_numbers) return {name: 'row'};
						if (activity.register_package_types) return {name: 'packaging'};
						if (activity.register_team_numbers) return {name: 'team'};
                    } else {
            if (activity.register_row_status) return {name: 'row-status'};
						if (activity.register_row_numbers) return {name: 'row'};
						if (activity.register_amounts) return {name: 'amount'};
						if (activity.register_package_types) return {name: 'packaging'};
						if (activity.register_team_numbers) return {name: 'team'};
                    }
				}

				return {name: 'activity'};
			},

            setRowPercentage (percentage) {
				      if (this.$store.state.enableTracking) writeTrackLog("Set row percentage: " + percentage);

				        const oldEntry = this.currentActivity;
                oldEntry.row_percentage = percentage;

                this.$store.dispatch('updateActivity', {
                    id: oldEntry.id,
                    'row_percentage': percentage
                });

                const route = this.$parent.determineRoute(oldEntry);

                if (route !== null && route !== undefined) return this.$router.push(route)
            }
        },

        mounted () {
            window.events.$emit('disableNumpad');
        },

        beforeDestroy () {
            window.events.$emit('enableNumpad');
        }
    }
</script>
